import apiClient from './apiClient';
// Get all topics
export const getTopics = (addtl) => {
  return apiClient('/topics'+addtl);
};

// Create a new topic
export const createTopic = (topicData) => {
  return apiClient('/topics', { body: topicData, method: 'POST' });
};

// Get messages for a topic
export const getTopicMessages = (topicId) => {
  return apiClient(`/topics/${topicId}/messages`);
};

// Send a message to a topic
export const sendMessage = (topicId, messageData) => {
  const messageBody = {"content": messageData};
  return apiClient(`/topics/${topicId}/messages`, { body: messageBody, method: 'POST' });
};